import { Component } from "@angular/core";
import { AuthService } from "../auth.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"]
})
export class ForgotPasswordComponent {
  model: any = {};
  isLoading = false;
  constructor(
    private signUpService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {

  }
  forgot(form) {
    if (form) {
      this.isLoading = true;
      this.spinner.show();
      this.signUpService.forgotPassword(this.model).subscribe(
        data => {
          if (data) {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            this.router.navigate(["/login"])
          }
        },

        err => {
          this.isLoading = false;
          this.spinner.hide();
          if (err) {
            this.toastr.error(err.message, "OOPS!"), {
              closeButton: true,
            };
          }

        }
      );
    }
  }
}
